import React from 'react';

type ArchiveIconSvgProps = {
  size?: number;
  color?: string;
};

/** Box/archive icon used for soft-archive actions (not permanent delete). */
const ArchiveIconSvg: React.FC<ArchiveIconSvgProps> = ({ size = 14, color = 'currentColor' }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: size, height: size, display: 'block' }}
    aria-hidden
  >
    <polyline points="21 8 21 21 3 21 3 8" />
    <rect x="1" y="3" width="22" height="5" />
    <line x1="10" y1="12" x2="14" y2="12" />
  </svg>
);

export default ArchiveIconSvg;
